/**
 * Retrieves the current network connection's downlink speed in megabits per second (Mbps).
 *
 * Note: This feature is not browser-compatible with Firefox, Safari, Safari on iOS, and WebView on iOS.
 *
 * @returns {number | undefined} The downlink speed in Mbps if available, or `undefined` if the
 *          `navigator.connection` API is not supported or the downlink information is unavailable.
 */
export const getConnectionDownlinkSpeedInMbps = (): number | undefined => {
  return navigator.connection?.downlink || undefined;
};
